import React, { useEffect, useState } from 'react';
import { Box, Button, Modal } from '@mui/material';
import { APIDataUrl, APITokenUrl } from '../../Utils/Utils';
import axios from 'axios';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';
import RequestFormControl from '../FormControlProfile/RequestFormControl';
import "../RequestUpdateModals/RequestUpdateModals.css"
import moment from 'moment';
import ClearIcon from '@mui/icons-material/Clear';

const LeadsProspectModal = ({ requestUpdateRecord, setRequestUpdateRecord, profileData, peopleId, setSelectedOuterRows,
    setSuccessModel, successModel
}) => {
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 450,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        organizationName: "",
        industryValue: "",
        website: "",
        linkedin: "",
        streetAddress: "",
        city: "",
        state: "",
        country: "",
        email: "",
        numberOfEmployees: "",
        revenue: "",
        phone: "",
        updatedAt: "",
        zipCode: "",
        dropDownData: {
            categories: [],
            num_employees: [],
            revenue_range: []
        }
    });

    useEffect(() => {
        if (profileData) {
            setFormData(prevFormData => ({
                ...prevFormData,
                organizationName: profileData?.name || "",
                industryValue: profileData?.categories || "",
                website: profileData?.website_url || "",
                linkedin: profileData?.linkedin || "",
                streetAddress: profileData?.street || "",
                country: profileData.country || "",
                email: profileData?.contact_email || "",
                city: profileData?.city ? profileData?.city : profileData?.location_identifiers?.split(",")?.[0] || "",
                state: profileData?.state ? profileData?.state : profileData?.location_identifiers?.split(",")?.[1] || "",
                numberOfEmployees: profileData?.num_employees || "",
                revenue: profileData?.revenue_range || "",
                zipCode: profileData?.postalcode,
                phone: profileData?.phone_number,
                updatedAt: profileData?.updated_at,
            }));
        }
    }, [profileData]);

    const GetIndustryData = () => {
        setLoading(true);
        const option = {
            method: "GET",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl(),
            },
            url: `${APIDataUrl()}/v1/org_filters`,
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                const data = JSON.parse(e?.request?.response);
                setFormData((prevState) => ({
                    ...prevState,
                    dropDownData: {
                        categories: data?.data?.categories || [],
                        num_employees: data?.data?.num_employees || [],
                        revenue_range: data?.data?.revenue_range || [],
                    }
                }));
            })
            .catch(() => {
                setLoading(false);
            });
    };

    // useEffect(() => {
    //     GetIndustryData();
    // }, []);

    useEffect(() => {
        if (requestUpdateRecord === true) {
            GetIndustryData()
        }
    }, [requestUpdateRecord])







    const handleModalTrue = () => {
        setSuccessModel(true)

    }

    const SendRequestUpdate = () => {

        setLoading(true);
        const data =
        {
            "user_id": 0,
            "org_id": peopleId,
            "name": formData?.organizationName,
            "website_url": formData?.website,
            "linkedin": formData?.linkedin,
            "street": formData?.streetAddress,
            "city": formData?.city,
            "state": formData?.state,
            "user_email": formData?.email,
            "categories": formData?.industryValue,
            "num_employees": formData?.numberOfEmployees,
            "revenue_range": formData?.revenue,
            "zip_code": formData?.zipCode,
            "phone_number": formData?.phone,
            "country": formData?.country,
            "inserted_date": formData?.updatedAt,
        };


        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl(),
            },
            url: `${APIDataUrl()}/v1/user_update_organization`,
            data: JSON.stringify(data),
        };

        axios(option)
            .then(() => {


                setLoading(false);
                setRequestUpdateRecord(false);
                handleModalTrue();
                // toast.success("Record update Requested Successfully");
                setSelectedOuterRows([])


            })
            .catch(() => {
                setLoading(false);
            });
    };

    return (
        <>
            {loading && <Loader />}
            <Modal
                open={requestUpdateRecord}
                onClose={() => { setRequestUpdateRecord(false); }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="vrufyerv">
                    <Box sx={style} style={{ overflowY: "auto", height: "90vh", width: "50%" }}>
                        <div className="de_pad-requpdate">
                            <div className='record-heading-titleLeadsprospect'>
                                <h3 className='record-update-head'>Record Update Request</h3>
                                <p className='de_head'>Simply provide the information you want updated on the record</p>
                                <p className='de_head'>Data Sync: -{profileData?.updated_at ? moment(profileData.updated_at).format("MM.DD.YY") : "No update information available"}</p>
                            </div>
                            {/* Organization Name Field */}
                            <div className="de_input_cont">
                                <label htmlFor="" className="label-floating">
                                    Organization Name
                                    {/* <span className="dt-en-red">({profileData?.name})</span> */}
                                </label>
                                <input
                                    type="text"
                                    disabled
                                    placeholder='Organization Name'
                                    value={formData.organizationName}
                                    onChange={(e) =>
                                        setFormData((prevState) => ({
                                            ...prevState,
                                            organizationName: e.target.value,
                                        }))
                                    }
                                />
                            </div>
                            <div className="de_input_cont">
                                <label htmlFor="" className="label-floating">
                                    Address
                                    {/* <span className="dt-en-red">({profileData?.name})</span> */}
                                </label>
                                <input
                                    type="text"
                                    placeholder='Address'
                                    value={formData.streetAddress}
                                    onChange={(e) =>
                                        setFormData((prevState) => ({
                                            ...prevState,
                                            streetAddress: e.target.value,
                                        }))
                                    }
                                />
                            </div>

                            <div className='country-city-request-model'>
                                <div className="de_input_cont-wdt">
                                    <label htmlFor="" className="label-floating">
                                        Country
                                        {/* <span className="dt-en-red">({profileData?.location_identifiers?.split(",")?.[0]})</span> */}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='Country'
                                        value={formData.country}
                                        onChange={(e) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                country: e.target.value,
                                            }))
                                        }
                                    />
                                </div>

                                <div className="de_input_cont-wdt">
                                    <label htmlFor="" className="label-floating">
                                        City
                                        {/* <span className="dt-en-red">({profileData?.location_identifiers?.split(",")?.[0]})</span> */}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='City'
                                        value={formData.city}
                                        onChange={(e) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                city: e.target.value,
                                            }))
                                        }
                                    />
                                </div>

                            </div>

                            <div className='country-city-request-model'>
                                <div className="de_input_cont">
                                    <label htmlFor="" className="label-floating">
                                        State
                                        {/* <span className="dt-en-red">({profileData?.location_identifiers?.split(",")?.[1]})</span> */}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='State'
                                        value={formData.state}
                                        onChange={(e) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                state: e.target.value,
                                            }))
                                        }
                                    />
                                </div>

                                <div className="de_input_cont">
                                    <label htmlFor="" className="label-floating">
                                        Zip code
                                        {/* <span className="dt-en-red">({profileData?.location_identifiers?.split(",")?.[1]})</span> */}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='Zip Code'
                                        value={formData.zipCode}
                                        onChange={(e) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                zipCode: e.target.value,
                                            }))
                                        }
                                    />
                                </div>

                            </div>

                            <div className='country-city-request-model'>
                                <div className="de_input_cont">
                                    <label htmlFor="" className="label-floating">
                                        Phone
                                        {/* <span className="dt-en-red">({profileData?.website_url})</span> */}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='Phone'
                                        value={formData.phone}
                                        onChange={(e) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                phone: e.target.value,
                                            }))
                                        }
                                    />
                                </div>

                                <div className="de_input_cont">
                                    <label htmlFor="" className="label-floating">
                                        Website URl
                                        {/* <span className="dt-en-red">({profileData?.website_url})</span> */}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='Website'
                                        value={formData.website}
                                        onChange={(e) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                website: e.target.value,
                                            }))
                                        }
                                    />
                                </div>

                            </div>

                            <div className='country-city-request-model'>
                                <div className="de_input_cont">
                                    <label htmlFor="" className="label-floating">
                                        Revenue Range
                                        {/* <span className="dt-en-red">({profileData?.revenue_range})</span> */}
                                    </label>
                                    <RequestFormControl
                                        value={formData.revenue}
                                        onChange={(e) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                revenue: e,
                                            }))
                                        }
                                        dataList={formData.dropDownData?.revenue_range}
                                    />
                                </div>

                                <div className="de_input_cont">
                                    <label htmlFor="" className="label-floating">
                                        Number of Employees
                                        {/* <span className="dt-en-red">({profileData?.num_employees})</span> */}
                                    </label>

                                    <RequestFormControl
                                        value={formData.numberOfEmployees}
                                        onChange={(e) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                numberOfEmployees: e,
                                            }))
                                        }
                                        dataList={formData.dropDownData?.num_employees}
                                    />
                                </div>


                            </div>
                            <div className='country-city-request-model'>
                                <div className="de_input_cont">
                                    <label htmlFor="" className="label-floating">
                                        LinkedIn URL
                                        {/* <span className="dt-en-red">({profileData?.linkedin})</span> */}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='LinkedIn URL'
                                        value={formData.linkedin}
                                        onChange={(e) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                linkedin: e.target.value,
                                            }))
                                        }
                                    />
                                </div>
                                <div className="de_input_cont">
                                    <label htmlFor="" className="label-floating">
                                        Industry/Sector
                                        {/* <span className="dt-en-red">({profileData?.categories})</span> */}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder='LinkedIn URL'
                                        value={formData.industryValue}
                                        onChange={(e) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                industryValue: e.target.value,
                                            }))
                                        }
                                    />
                                    {/* <RequestFormControl
                                        value={formData?.industryValue}
                                        onChange={(e) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                industryValue: e,
                                            }))
                                        }
                                        dataList={formData.dropDownData?.categories}
                                    /> */}

                                </div>

                            </div>
                            <div className="de_hr">
                                <div className='de_btn_cont'>
                                    <Button className='de_cancel' onClick={() => setRequestUpdateRecord(false)}>Cancel</Button>
                                    <Button className='de_next' onClick={SendRequestUpdate}>Submit</Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>


        </>
    );
};

export default LeadsProspectModal;

// import React, { useEffect, useState } from 'react'
// import { Box, Button, InputBase, Modal, Paper } from '@mui/material'
// import { APIDataUrl, APITokenUrl } from '../../Utils/Utils';
// import axios from 'axios';
// import CloseIcon from '@mui/icons-material/Close';
// import Loader from '../Loader/Loader';
// import RequestFormControl from '../RequestFormControl/Index';
// import { toast } from 'react-toastify';

// const LeadsProspectModal = ({ requestUpdateRecord, setRequestUpdateRecord, profileData, peopleId }) => {
//     const style = {
//         position: "absolute",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         width: 450,
//         bgcolor: "background.paper",
//         boxShadow: 24,
//         borderRadius: "8px",
//     };

//     const [loading, setLoading] = useState(false)
//     const [organizationName, setOrganizationName] = useState("");
//     const [dropDownData, setDropDownData] = useState([])
//     const [industryValue, setIndustryValue] = useState("")
//     const [website, setWebsite] = useState()
//     const [linkedin, setLinkedin] = useState()
//     const [streetAddress, setStreetAddress] = useState()
//     const [city, setCity] = useState()
//     const [state, setState] = useState()
//     const [numberOfEmployees, setNumberOfEmployees] = useState()
//     const [revenue, setRevenue] = useState()

//     const GetIndustryData = () => {
//         setLoading(true);
//         const option = {
//             method: "GET",
//             headers: {
//                 "access-control-allow-origin": "*",
//                 "content-type": "application/json",
//                 "X-API-Key": APITokenUrl()
//             },
//             url: `${APIDataUrl()}/v1/org_filters`,
//         };
//         axios(option)
//             .then((e) => {
//                 setLoading(false);
//                 const data = JSON.parse(e?.request?.response);

//                 setDropDownData(data?.data);

//             })
//             .catch(() => {
//                 setLoading(false);
//             });
//     };
//     useEffect(() => {
//         GetIndustryData()
//     }, [])
//     const SendtRequestUpdate = () => {
//         setLoading(true);
//         const data = [
//             {
//                 "id": 0,
//                 "org_id": peopleId,
//                 "organization_name": organizationName,
//                 "website": website,
//                 "linkedin_Url": linkedin,
//                 "street_address": streetAddress,
//                 "city": city,
//                 "state": state,
//                 "industry": industryValue,
//                 "number_of_Employees": numberOfEmployees,
//                 "revenue": revenue,
//                 "zipCode":""
//             }
//         ]

//         const option = {
//             method: "POST",
//             headers: {
//                 "access-control-allow-origin": "*",
//                 "content-type": "application/json",
//                 "X-API-Key": APITokenUrl()
//             },
//             url: `${APIDataUrl()}/v1/save_request_update_org`,
//             data: JSON.stringify(data),
//         };
//         axios(option)
//             .then((response) => {
//                 setLoading(false);
//                 setRequestUpdateRecord(false)
//                 toast.success("Record update Requested Successfully")
//             })
//             .catch((error) => {
//                 setLoading(false);
//             });

//     }
//     return (
//         <>
//             {loading ? <Loader /> : null}
//             <Modal
//                 open={requestUpdateRecord}
//                 onClose={() => { setRequestUpdateRecord(false) }}
//                 aria-labelledby="modal-modal-title"
//                 aria-describedby="modal-modal-description"
//             >
//                 <div className="vrufyerv">
//                     <Box sx={style} style={{ overflowY: "auto", height: "90vh" }}>
//                         <div className="de_pad">
//                             <h3>Record Update Request</h3>
//                             <p className='de_head'>Simply provide the information you want  updated on the record </p>

//                             {/* Organization Name Field */}
//                             <div className="de_input_cont">
//                                 <label htmlFor="" className="label-floating">
//                                     Organization Name<span className="dt-en-red">({profileData?.name})</span>
//                                 </label>
//                                 <input
//                                     type="text"
//                                     placeholder='Organization Name'
//                                     value={organizationName}
//                                     onChange={(e) => setOrganizationName(e?.target?.value)}
//                                 />
//                             </div>
//                             {/* Industry/sector */}
//                             <div className="de_input_cont">
//                                 <label htmlFor="" className="label-floating">
//                                     Industry/Sector<span className="dt-en-red">({profileData?.categories})</span>
//                                 </label>
//                                 <RequestFormControl
//                                     value={industryValue}
//                                     handleChange={(e) => setIndustryValue(e?.target?.value)}
//                                     dataList={dropDownData?.categories}
//                                 />
//                             </div>

//                             {/* Website Field */}
//                             <div className="de_input_cont">
//                                 <label htmlFor="" className="label-floating">
//                                     Website<span className="dt-en-red">({profileData?.website_url})</span>
//                                 </label>
//                                 <input
//                                     type="text"
//                                     placeholder='Website'
//                                     value={website}
//                                     onChange={(e) => setWebsite(e?.target?.value)}
//                                 />
//                             </div>

//                             {/* LinkedIn URL Field */}
//                             <div className="de_input_cont">
//                                 <label htmlFor="" className="label-floating">
//                                     LinkedIn URL<span className="dt-en-red">({profileData?.linkedin})</span>
//                                 </label>
//                                 <input
//                                     type="text"
//                                     placeholder='LinkedIn URL'
//                                     value={linkedin}
//                                     onChange={(e) => setLinkedin(e?.target?.value)}
//                                 />
//                             </div>

//                             {/* Street Address Field */}
//                             <div className="de_input_cont">
//                                 <label htmlFor="" className="label-floating">
//                                     Street Address<span className="dt-en-red">({profileData?.street})</span>
//                                 </label>
//                                 <input
//                                     type="text"
//                                     placeholder='Street Address'
//                                     value={streetAddress}
//                                     onChange={(e) => setStreetAddress(e?.target?.value)}
//                                 />
//                             </div>

//                             {/* city Field */}
//                             <div className="de_input_cont">
//                                 <label htmlFor="" className="label-floating">
//                                     City<span className="dt-en-red">({profileData?.location_identifiers?.split(",")?.[0]})</span>
//                                 </label>
//                                 <input
//                                     type="text"
//                                     placeholder='City'
//                                     value={city}
//                                     onChange={(e) => setCity(e?.target?.value)}
//                                 />
//                             </div>

//                             {/* state Field */}
//                             <div className="de_input_cont">
//                                 <label htmlFor="" className="label-floating">
//                                     State<span className="dt-en-red">({profileData?.location_identifiers?.split(",")?.[1]})</span>
//                                 </label>
//                                 <input
//                                     type="text"
//                                     placeholder='State'
//                                     value={state}
//                                     onChange={(e) => setState(e?.target?.value)}
//                                 />
//                             </div>
//                             {/* num of employees Field */}
//                             <div className="de_input_cont">
//                                 <label htmlFor="" className="label-floating">
//                                     Number of Employees<span className="dt-en-red">({profileData?.num_employees})</span>
//                                 </label>
//                                 <RequestFormControl
//                                     value={numberOfEmployees}
//                                     handleChange={(e) => setNumberOfEmployees(e?.target?.value)}
//                                     dataList={dropDownData?.num_employees}
//                                 />
//                             </div>
//                             {/* Revenue Range Field */}
//                             <div className="de_input_cont">
//                                 <label htmlFor="" className="label-floating">
//                                     Revenue Range<span className="dt-en-red">({profileData?.revenue_range})</span>
//                                 </label>
//                                 <RequestFormControl
//                                     value={revenue}
//                                     handleChange={(e) => setRevenue(e?.target?.value)}
//                                     dataList={dropDownData?.revenue_range}
//                                 />
//                             </div>

//                             <div className="de_hr">
//                                 <div className='de_btn_cont'>
//                                     <Button className='de_cancel' onClick={() => setRequestUpdateRecord(false)}>Cancel</Button>
//                                     <Button className='de_next' onClick={() => SendtRequestUpdate()} >Submit</Button>
//                                 </div>
//                             </div>
//                         </div>
//                     </Box>
//                 </div>
//             </Modal>
//         </>
//     )
// }

// export default LeadsProspectModal
